import { ICell } from 'models/interfaces/spreadsheet-types/core-types';

const getLedgerInfluencedCells = (
  aliases: { rowNumber: number }[],
  cells: { [key: string]: ICell },
  columnLegend: string
) => aliases.map(({ rowNumber }) => cells[columnLegend + rowNumber]);

export default getLedgerInfluencedCells;
